import React, { SVGProps } from 'react';
type SVGRProps = {
  titleId?: string;
};
const SvgIcoSmartphone = ({ titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    <title id={titleId}>Smartphone</title>
    <rect x={9.572} y={3.285} width={12.857} height={25.429} rx={1.286} stroke="currentColor" strokeWidth={2} />
    <rect x={12.572} y={2.857} width={6.857} height={2.286} rx={1.143} fill="currentColor" />
  </svg>
);
export default SvgIcoSmartphone;
